<template lang="html">
  <div class="edit-site-favicon tier tier-three">
    <Tooltip content="Your favicon will appear in the browsers address bar" />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs :headings="['Favicon', 'Favicon Design']">
        <Tab>
          <div>
            <FileUploadForm
              label="Favicon"
              helpText="File types accepted: <strong>PNG</strong>"
              paramResource="site"
              paramName="favicon"
              :showUnsplash="false"
              :image="site.favicon_path"
              :stringUpdateFunction="stringUpdateFunction"
              :fileUpdateFunction="fileUpdateFunction"
              :errors="errors"
            />

            <Btn
              v-if="site.favicon_path"
              class="btn-remove"
              secondary
              @click="deleteFavicon"
            >
              Delete Favicon
            </Btn>
          </div>
        </Tab>

        <Tab>
          <div>
            <div class="helper-text">
              <p>
                To create a custom favicon, we recommend using
                <a
                  href="https://favicon.io?utm_source=PageMakerPro"
                  target="_blank"
                  >favicon.io</a
                >. Please upload a <strong>PNG</strong> or
                <strong>JPG</strong> image.
              </p>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'
import {mapGetters} from 'vuex'

import {
  updateCompanySiteData,
  updateCompanySiteFaviconImage,
  deleteCompanySiteFaviconImage,
  readCompanySiteData
} from '@/lib/sites'

import Btn from '@/components/Btn'
import Tooltip from '@/components/Tooltip'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import FileUploadForm from '@/components/forms/FileUploadForm'

export default {
  name: 'EditSiteFavicon',

  components: {
    Btn,
    Tooltip,
    Tabs,
    Tab,
    FileUploadForm
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    ...mapGetters(['sessionToken']),

    title() {
      return `Editing ${this.site.name} Favicon`
    },

    stringUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId

      return (favicon) => {
        return updateCompanySiteData(companyId, siteId, favicon)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data

            this.$emit('updatePage')
            this.triggerNotification('success', 'favicon', 'uploaded')
            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    },

    fileUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId
      const token = this.sessionToken

      return (favicon) => {
        return updateCompanySiteFaviconImage(companyId, siteId, favicon, token)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data

            this.$emit('updatePage')
            this.triggerNotification('success', 'favicon', 'uploaded')
            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    }
  },

  methods: {
    deleteFavicon() {
      deleteCompanySiteFaviconImage(this.companyId, this.siteId).then(() => {
        this.site.favicon_path = null
        this.$emit('updatePage')
        this.triggerNotification('success', 'favicon', 'deleted')
      })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
